export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7373.c6f7564c.jpg";